<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-checkbox--disabled': disabledCombined}, {'hm-checkbox--has-label': showLabel}]" class="hm-checkbox">
    <div class="hm-checkbox__wrapper">
      <span class="hm-checkbox__label" v-html="label" />
      <div class="hm-checkbox">
        <input :id="`checkbox_${_uid}`" :disabled="disabledCombined" v-model="internalValue" type="checkbox">
        <label :for="`checkbox_${_uid}`"></label>
      </div>
    </div>
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'HmInputCheckbox',

  mixins: [HmInputMixin, GridMixin],

  props: {
    showLabel: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data: function () {
    return {
    };
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';

$checkbox-size: 20px;

.hm-checkbox {
  position: relative;
  left: 0;
  top: 0;
  float: left;
  width: $checkbox-size;
  height: $checkbox-size;
  cursor: pointer;

  &__label {
    display: none;
  }

  input {
    pointer-events: none;
  }

  &--has-label {
    margin-top: 1.2rem;
    .hm-checkbox {
      &__label {
        display: block;
        position: absolute;
        left: 0.6rem;
        color: $gray;
        transition: all 0.2s ease;
        z-index: 2;
        background-color: $white;
        padding: 0 0.4rem;
        border-radius: 0.3rem;
        will-change: top, font-size;
        max-width: 100%;
        top: -1.4rem;
        left: 0.6rem;
        font-size: 1.1rem;
        color: $text;

        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  &--disabled {
    cursor: not-allowed;
    label {
      cursor: not-allowed;
    }

    .hm-checkbox__wrapper {
      pointer-events: none;

      &:after {
        content: ' ';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: $lightmiddlegray;
        opacity: 0.85;
        border: 1px solid $middlegray;
        border-radius: 0.3rem;
      }
    }
  }

  &__wrapper {
    position: relative;
    height: $checkbox-size;
    display: inline-block;
  }

  label {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
    left: 0;
    top: 0;
    cursor: pointer;
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 0 0;
      background-image: url('~png/checkbox-unchecked.png');
    }
  }

  input[type='checkbox'] {
    opacity: 0;
    margin: 0;
    z-index: -1;
    position: absolute;
    left: 0;
    margin: 0;
    &:checked {
      +label {
        &:before {
          background-image: url('~png/checkbox-checked.png');
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputCheckbox.vue